import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AvailableCourseSection } from 'src/app/models/available-course-section';
import { PacedCourseOffering } from 'src/app/models/paced-course-offering';
import { environment } from 'src/environments/environment';
import { ERROR_MESSAGES } from 'src/app/constants/error-messages';

@Injectable({
  providedIn: 'root'
})
export class PacedCourseOfferingService {

  constructor(private readonly http: HttpClient) { }

  // TODO: Replace all "sync-element" usages (frontend + backend) with the new name "course-offering".
  // This includes API endpoints, services, models, and related DTOs.
  // Update the methods in this file once the backend endpoint is renamed.
  getAvailableCourseSections(courseId: number): Observable<AvailableCourseSection[]> {
    return this.http.get<AvailableCourseSection[]>(`${environment.apiUrl}/paced-sync-elements/course-essence/${courseId}/available/course-sections`);
  }

  getPacedCourseOfferings(courseId: number): Observable<PacedCourseOffering[]> {
    return this.http.get<PacedCourseOffering[]>(`${environment.apiUrl}/paced-sync-elements/course-essence/${courseId}`);
  }

  create(courseId: number, pe: PacedCourseOffering): Observable<boolean> {
    return this.http.post<number>(`${environment.apiUrl}/paced-sync-elements/`, {
      courseEssenceId: courseId,
      crn: pe.key.crn,
      termCode: pe.key.termCode,
      options: pe.options
    }).pipe(
      map(() => true),
      catchError(err => this.handleApiError(err))
    );
    
  }

  update(pe: PacedCourseOffering): Observable<boolean> {
    return this.http.patch<void>(`${environment.apiUrl}/paced-sync-elements/`, {
      id: pe.id,
      options: pe.options
    }).pipe(
      map(() => true),
      catchError(err => this.handleApiError(err))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/paced-sync-elements/${id}`);
  }

  handleApiError(err: any): Observable<never> {
    let errorCode: string | undefined;
  
    if (Array.isArray(err?.error?.message)) {
      errorCode = err.error.message[0];
    }
  
    const message = ERROR_MESSAGES[errorCode ?? ''] || 'Something went wrong. Please try again.';
    return throwError(() => new Error(message));
  }
}

